<template>
  <!-- 풋터 -->
  <footer class="section_08">
    <div class="width_margin">
      <div class="section_08_aboutus_faq_container">
        <div class="section_08_aboutus_faq_box">
          <div>
            <div class="section_08_aboutus pointer" @click="clickMore('https://carrotenglish.com/carrot/index.html')">회사소개</div>
            <!-- <div
              class="section_08_faq pointer"
              @click="clickMore('https://www.carrotglobal.com/global/faq.html')"
            >
              FAQ
            </div> -->
          </div>
          <div class="section_08_follow_sns_select">
            <span class="section_08_follow">FOLLOW US:</span>
            <img class="pointer" src="~@/assets/img/global/icon_social1.png" @click="clickMore('https://www.instagram.com/carrotglobal/')" /><img class="pointer" src="~@/assets/img/global/icon_social2.png" @click="clickMore('https://www.facebook.com/thecarrotglobal/')" /><img class="pointer" src="~@/assets/img/global/icon_social3.png" @click="clickMore('https://blog.naver.com/carrotblog')" />
          </div>
        </div>
        <div class="section_08_sns_box">
          <!-- <div class="section_08_follow_sns_select">
            <span class="section_08_follow">FOLLOW US:</span>
            <img
              class="pointer"
              src="~@/assets/img/global/icon_social1.png"
              @click="clickMore('https://www.instagram.com/carrotglobal/')"
            /><img
              class="pointer"
              src="~@/assets/img/global/icon_social2.png"
              @click="clickMore('https://www.facebook.com/thecarrotglobal/')"
            /><img
              class="pointer"
              src="~@/assets/img/global/icon_social3.png"
              @click="clickMore('https://blog.naver.com/carrotblog')"
            />
          </div> -->
          <select class="section_08_selectbox" @change="changeSelectBox" v-model="site">
            <option value="">Family Site</option>
            <option value="http://carrotglobal.com/">CARROT HUB</option>
            <option value="https://www.carrotenglish.kr/">전화영어:모바일 화상</option>
            <!-- <option value="https://www.carrotglobal.com/global/index.html">
              기업교육/컨설팅(B2B,B2G)
            </option> -->
            <option value="http://carrotglobal.net/">CARROT Global</option>
            <option value="https://www.how-writing.com/how_intro">HOW</option>
            <option value="http://www.thespac.net/new/">SPAC</option>
            <option value="https://www.imooc.co.kr/">i:MOOC</option>
            <option value="https://gosiliconvalley.co.kr/">GoSiliconvalley</option>
            <option value="https://www.expatcare.co.kr/">리:로케이션</option>
          </select>
        </div>
      </div>
    </div>

    <div class="section_08_line"></div>

    <div class="width_margin">
      <div class="section_08_tel_email_address_box">
        <div class="section_08_tel">연락처 : 02 - 518 - 0036</div>
        <div class="section_08_email">edu@carrotglobal.com</div>

        <div class="section_08_tel_email_mobile">
          <div class="section_08_tel_mobile">연락처 : 02 - 518 - 0036</div>
          <div class="section_08_email_mobile">edu@carrotglobal.com</div>
        </div>

        <div class="section_08_address">주소: 서울특별시 용산구 한남동 이태원로 268-20 캐럿글로벌</div>
      </div>
      <div class="section_08_ceo_reserved_box">
        <div class="section_08_ceo">㈜캐럿글로벌 대표이사 : 노상충</div>
        <div class="section_08_reserved">©CARROT Global Inc. All Rights reserved.</div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      site: "",
    };
  },
  methods: {
    clickMore(path) {
      window.open(path, "_blank");
    },
    changeSelectBox() {
      if (this.site) {
        window.open(this.site, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 공통
.width_margin {
  max-width: 1300px;
  margin: 0 auto;
  padding: 25px;
}

.section_08 {
  // height: 363px;
  background-color: #323232;
  .section_08_aboutus_faq_container {
    display: flex;
    // padding-top: 57px;
    align-items: center;
    // padding-bottom: 18px;
    justify-content: space-between;
    .section_08_aboutus_faq_box {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0 32px;

      > div {
        display: flex;
        font-size: 15px;
        line-height: 1.4;
        text-align: left;
        color: #686868;
        font-style: normal;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: -0.75px;
      }

      .section_08_aboutus {
        position: relative;
        // padding-right: 10px;
        // &::after {
        //   content: "";
        //   position: absolute;
        //   top: 2px;
        //   right: 4px;
        //   width: 1.5px;
        //   height: 80%;
        //   background: #686868;
        // }
      }

      .section_08_follow_sns_select {
        align-items: center;
        gap: 0 9px;
      }
    }
    .section_08_sns_box {
      display: flex;
      font-size: 15px;
      line-height: 1.4;
      text-align: left;
      color: #686868;
      font-style: normal;
      padding-right: 9px;
      align-items: center;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: -0.75px;

      .section_08_follow {
        padding-right: 9px;
      }
      img {
        padding-right: 9px;
      }
      .section_08_selectbox {
        width: 210px;
        height: 38px;
        font-size: 15px;
        line-height: 1.4;
        color: #686868;
        font-style: normal;
        font-weight: normal;
        font-stretch: normal;
        padding-left: 17px;
        letter-spacing: -0.75px;
        background-color: #fff !important;
        background: url(~@/assets/img/global/icon_downarrow.png) no-repeat 95% 50%/12px auto;
      }
    }
  }
  .section_08_line {
    opacity: 0.3;
    border-bottom: 1px solid #686868;
  }
  .section_08_tel_email_address_box {
    display: flex;
    font-size: 15px;
    line-height: 1.4;
    color: #686868;
    // padding-top: 37px;
    font-style: normal;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: -0.75px;
    .section_08_tel_email_mobile {
      display: none;
    }

    .section_08_tel {
      position: relative;
      padding-right: 10px;
      &::after {
        content: "";
        position: absolute;
        top: 3px;
        right: 4px;
        width: 1px;
        height: 75%;
        background: #686868;
      }
    }
    .section_08_email {
      padding-right: 15px;
    }
  }
  .section_08_ceo_reserved_box {
    color: #686868;
    font-size: 15px;
    line-height: 1.4;
    font-style: normal;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: -0.75px;
  }
}

@media only screen and (max-width: 1385) {
  .width_margin {
    width: 80% !important;
    margin: 0 auto;
  }
}

@media only screen and (max-width: 1000px) {
}

@media only screen and (max-width: 768px) {
  .section_08 {
    .width_margin {
      .section_08_aboutus_faq_container {
        padding-top: 0px;
        flex-direction: column;
        align-items: flex-start;
        .section_08_aboutus_faq_box {
          justify-content: space-between;
          font-size: 13px;
          .section_08_aboutus {
            &::after {
              content: "";
              position: absolute;
              top: 2px;
              right: 4px;
              width: 1.5px;
              height: 71%;
            }
          }
        }
        .section_08_sns_box {
          flex-direction: column;
          align-items: flex-start;
          .section_08_follow {
            font-size: 13px;
            padding-bottom: 15px;
          }
          .section_08_selectbox {
            font-size: 13px;
            margin-top: 20px;
            margin-left: 0px;
            padding-left: 18px;
          }
        }
      }
    }
    .width_margin {
      background-color: #323232;
      .section_08_tel_email_address_box {
        font-size: 13px;
        flex-direction: column;
        .section_08_tel {
          display: none;
        }
        .section_08_email {
          display: none;
        }
        .section_08_tel_email_mobile {
          display: flex;
        }
        .section_08_tel_mobile {
          position: relative;
          padding-right: 10px;
          &::after {
            content: "";
            top: 2px;
            right: 4px;
            height: 71%;
            width: 1.5px;
            position: absolute;
            background: #686868;
          }
        }
      }
      .section_08_ceo_reserved_box {
        font-size: 13px;
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .section_08 {
    .width_margin {
      display: block;
      padding: 25px;
    }
  }
}

@media only screen and (max-width: 360px) {
  .section_08 {
    .width_margin {
      .section_08_aboutus_faq_container {
        // padding-top: 59px;
        flex-direction: column;
        align-items: flex-start;
        .section_08_aboutus_faq_box {
          font-size: 13px;
          padding-bottom: 15px;
          .section_08_aboutus {
            &::after {
              content: "";
              position: absolute;
              top: 2px;
              right: 4px;
              width: 1.5px;
              height: 71%;
            }
          }
        }
        .section_08_sns_box {
          .section_08_follow {
            font-size: 13px;
            padding-bottom: 15px;
          }
          .section_08_selectbox {
            font-size: 13px;
            margin-top: 15px;
            margin-left: 0px;
            padding-left: 18px;
          }
        }
      }
    }
    .width_margin {
      .section_08_tel_email_address_box {
        font-size: 13px;
        flex-direction: column;
        .section_08_tel {
          display: none;
        }
        .section_08_email {
          display: none;
        }
        .section_08_tel_email_mobile {
          display: flex;
        }
        .section_08_tel_mobile {
          position: relative;
          padding-right: 10px;
          &::after {
            content: "";
            top: 2px;
            right: 4px;
            height: 71%;
            width: 1.5px;
            position: absolute;
          }
        }
      }
      .section_08_ceo_reserved_box {
        font-size: 13px;
      }
    }
  }
}
</style>
